import React from 'react'
import AccordionServicos from './accordionServicos'
import CardServicos from './cardServicos'
import Container from './container'

export default function SquadBeneficios({ title, cards = [] }) {
  // Check if we have exactly 3 cards for special layout
  const hasExactlyThreeCards = cards.length === 3

  // Split cards into rows based on the number of cards
  const firstRowCards = hasExactlyThreeCards ? [] : cards.slice(0, 2) // First row has text + 2 cards when not 3 cards
  const secondRowCards = hasExactlyThreeCards ? cards : cards.slice(2) // All 3 cards in one row or remaining cards

  return (
    <div className="w-full bg-[#040116] pt-[71px] pb-20 lg:py-32 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="w-full h-full object-cover"
        />
        <img
          src="/assets/grafismos.svg"
          alt="Grafismos"
          className="absolute inset-0 w-full h-full object-cover rotate-180"
        />
      </div>

      <Container className="hidden lg:block relative z-10">
        {/* Special layout for exactly 3 cards */}
        {cards.length === 3 ? (
          <>
            {/* Title centered above cards */}
            <div className="text-white flex justify-center mb-24">{title}</div>

            {/* All 3 cards in one row */}
            <div className="grid grid-cols-3 gap-6">
              {cards.map((card, index) => (
                <div key={index}>
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                  />
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            {/* Standard layout for other card counts */}
            <div className="grid grid-cols-3 gap-6 mb-8">
              {/* Text Column */}
              <div className="text-white flex items-center justify-center h-full">
                {title}
              </div>

              {/* First row cards */}
              {firstRowCards.map((card, index) => (
                <div key={index}>
                  <CardServicos
                    icon={card.icon}
                    iconHover={card.iconHover || card.icon}
                    title={card.title}
                    text={card.text}
                    glowColor={card.glowColor || '#A002CB'}
                    url={card.url}
                    className="w-full md:w-auto"
                  />
                </div>
              ))}
            </div>
          </>
        )}

        {/* Second row with remaining cards (only for non-3-card layouts) */}
        {cards.length !== 3 && secondRowCards.length > 0 && (
          <div className="grid md:grid-cols-3 gap-6">
            {secondRowCards.map((card, index) => (
              <div key={index}>
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="w-full md:w-auto"
                />
              </div>
            ))}
            {/* Add empty divs to maintain grid structure if row is not full */}
            {Array.from({ length: 3 - secondRowCards.length }).map((_, i) => (
              <div key={`empty-${i}`} />
            ))}
          </div>
        )}
      </Container>

      <Container className="hidden md:block lg:hidden">
        <>
          {/* Standard layout for other card counts */}
          <div className="grid grid-cols-2 gap-6 mb-8">
            {/* Text Column */}
            <div className="text-white flex items-center justify-center h-full">
              {title}
            </div>

            {/* First row cards */}
            {firstRowCards.map((card, index) => (
              <div key={index}>
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="w-full md:w-auto"
                />
              </div>
            ))}
            {secondRowCards.map((card, index) => (
              <div key={index}>
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="w-full md:w-auto"
                />
              </div>
            ))}
          </div>
        </>
      </Container>

      <Container className="relative z-10 md:hidden space-y-14">
        <div className="text-white flex justify-center">{title}</div>

        {firstRowCards.map((card, index) => (
          <div key={index} className="mb-6">
            <AccordionServicos
              icon={card.icon}
              iconHover={card.iconHover || card.icon}
              title={card.title}
              text={card.text}
              glowColor={card.glowColor || '#A002CB'}
              url={card.url}
              className=""
            />
          </div>
        ))}
        {secondRowCards.map((card, index) => (
          <div key={index} className="mb-6">
            <AccordionServicos
              icon={card.icon}
              iconHover={card.iconHover || card.icon}
              title={card.title}
              text={card.text}
              glowColor={card.glowColor || '#A002CB'}
              url={card.url}
            />
          </div>
        ))}
      </Container>
    </div>
  )
}
